import { useCallback } from 'react';

export default function useFileUploadValidator(min_files: number = 0, max_files: number = 20, allowedExtensions: string[] = []) {
    return useCallback(
        (value: any[]) => {           
            const count = value?.length ?? 0;
            if (min_files > 0 && count < min_files) {
                return 'Required. Please select a file to upload.';
            }
            
            if(allowedExtensions.length > 0 && value.some((x) => !allowedExtensions.includes(x.extension.toLowerCase())))
                return `Invalid file type. Please upload a file with one of the following allowed extensions: ${ allowedExtensions.toString() }`           
            
            return count > max_files ? `File count exceeds the maximum of ${max_files} file${max_files > 1 ? 's' : ''}` : '';
        },
        [max_files, min_files]
    );
}